import { useCallback } from 'react';
import { logErrorToSentry } from '../Sentry';
import { useBrowser } from '../services/BrowserService';
import { useFetch } from '../services/NetworkService';
import { env } from '../util/env';
import { useUserData } from './UserProvider';

const { MEGATRON_HOST } = env;

const LOGOUT_URL = MEGATRON_HOST + '/members/logout';

/**
 * @param callback? action to call after successful logout
 */
export const useLogout = (callback?: VoidFunction) => {
  const { window } = useBrowser();
  const refetchUser = useUserData().refetch;
  const fetch = useFetch();

  return useCallback(() => {
    if (window) {
      fetch(LOGOUT_URL, {
        method: 'GET',
        headers: {
          'content-type': 'application/json; charset=utf-8',
          accept: 'application/json, application/x-auth-location',
        },
      })
        .then(response => {
          const authLocation = response.headers.get('auth-location');

          if (authLocation) {
            // call the redirect (which should be mom)...
            return fetch(authLocation, {
              method: 'GET',
              credentials: 'include',
              headers: {
                'content-type': 'application/json; charset=utf-8',
                accept: 'application/json',
              },
            }).then(authResp => {
              // trigger refresh of user context
              refetchUser?.();
              // call callback if set
              callback?.();

              return authResp;
            });
          }

          return response;
        })
        .catch(error => {
          logErrorToSentry('Failed to log out', error);
        });
    }
  }, [callback, fetch, refetchUser, window]);
};
